<template>
	<div class="header-submenu">
		<div class="header-submenu__learn">
			<p class="header-submenu__title">Knowledge Base</p>
			<div class="header-submenu__items">
				<a :href="learnItem.url" :class="`header-submenu__item--${learnItem.slug}`" v-for="learnItem in learnItems">
					<div class="header-submenu__item" @click="$emit('close-menu')">
						<img :src="learnItem.icon" />
						<div class="header-submenu__link">{{ learnItem.name }}</div>
					</div>
				</a>
			</div>
		</div>
		<ATInAction></ATInAction>
	</div>
</template>
<script>
import ATInAction from '../header/ATInAction.vue';

export default {
	data() {
		return {
			learnItems: [
				{
					slug: 'user-guide',
					icon: '/dist/img/header/help/user-guide.svg',
					name: 'User Guide',
					url: '/user-guide',
				},
				{
					slug: 'how-to-videos',
					icon: '/dist/img/header/help/how-to-videos.svg',
					name: 'How-to Videos',
					url: '/how-to-videos',
				},
				{
					slug: 'admin-guide',
					icon: '/dist/img/header/help/admin-guide.svg',
					name: 'Admin Guide',
					url: '/administration-guide',
				},
				{
					slug: 'faq',
					icon: '/dist/img/header/help/faq.svg',
					name: 'FAQ',
					url: '/faq-start',
				},
				{
					slug: 'api-guide',
					icon: '/dist/img/header/help/api-guide.svg',
					name: 'API Guide',
					url: '/api-documentation',
				},
				{
					slug: 'getting-more-efficient-with-actitime',
					icon: '/dist/img/header/help/tips.svg',
					name: 'actiTIME Tips',
					url: '/getting-more-efficient-with-actitime',
				},
			],
		};
	},

	components: {
		ATInAction,
	},
};
</script>

<style lang="scss">
@import '../../../../scss/layout/header/header-submenu.scss';
</style>



// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/header/Help.vue